export default __webpack_public_path__ + "static/media/atom-i-info.fa5cc3c8.svg";